<div class="container-fluid mt-5 mb-4" style="width: 90%;" isLoading="isLoading">
    <h1 class="mb-0">{{connectedUser.firstName}} {{connectedUser.lastName}}</h1>
    <p class="fw-light">Manage your details and personal preferences here.</p>

    <mat-divider class="mb-4 mt-4"></mat-divider>

    <div class="row ps-4">

        <button mat-raised-button class="m-2" style="width: 10%;" (click)="onAddLogo()"
            *ngIf="isUserWhiteLabel && !hasLogo">Add Logo</button>
        <button mat-raised-button class="m-2" style="width: 10%;" (click)="onDeleteLogo()"
            *ngIf="isUserWhiteLabel && hasLogo">Delete Logo</button>
        <button mat-raised-button color="warn" [disabled]="hasPayed" class="m-2" (click)="cancelPlan()"
            style="width: 20%;">Cancel subscription</button>
    </div>

    <div class="row mt-5">
        <app-update-user-info [connectedUser]="connectedUser"></app-update-user-info>
    </div>
    <div class="row mt-5">
        <app-api-key [connectedUser]="connectedUser"></app-api-key>
    </div>

</div>

<div class="container h-100 d-flex align-items-center p-5" *ngIf="isLoading">
    <mat-spinner [diameter]="60" [strokeWidth]="3" class="mx-auto"></mat-spinner>
</div>